import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

import SiteIcons from "@/components/SiteIcons/SiteIcons";

function CircularProgressWithLabel(props) {
  let { progress } = props;
  if (isNaN(progress)) progress = 0;
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <SiteIcons
        iconstring="circular-loader"
        variant="determinate"
        value={progress}
        page="sitewide-loader"
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div">
          {`${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  progress: PropTypes.number,
};

export default CircularProgressWithLabel;
